// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MediaQuery from 'react-responsive';
import Paper from '@material-ui/core/Paper';

import Navigation from '../../../common/Navigation/Navigation';
import { AccountTab } from '../components';
import styles from './styles';

const AccountPage = ({ classes }) => {
  const paperInner = () => {
    return (
      <div className={classes.contentContainer}>
        <div className={classes.topTextContainer}>
          <h3 className={classes.topText}>MY ACCOUNT</h3>
        </div>
        <AccountTab />
      </div>
    );
  };
  return (
    <Navigation mobileLikeIndex={false}>
      <div className={classes.mainContainer}>
        <MediaQuery minWidth={800}>
          {matches => (matches
            ? <Paper className={classes.mainPaper}>{paperInner()}</Paper>
            : paperInner())}
        </MediaQuery>
      </div>
    </Navigation>
  );
};

AccountPage.propTypes = {
  classes: PropTypes.object,
};

AccountPage.defaultProps = {
  classes: {},
};

export default withStyles(styles)(AccountPage);
